import React, { useEffect, useState } from 'react';
import { usePagination, withPaginate } from '@contexts/Paginate/PaginateContext';
import { compose } from 'redux';
import rootApi from '@utils/baseAPI/WrapperApi';
import { useQuery } from 'react-query';
import moment from 'moment';
import { Box } from '@mui/system';
import ActViewDetail from './ActionTable/ActViewDetail';
import DialogsViewDetail from './Dialogs/DialogsViewDetail';
import DialogsChangeRole from './Dialogs/DialogsChangeRole';
import ActChangeRole from './ActionTable/ActChangeRole';
import ActDeleteUser from './ActionTable/ActDelete';
import ActEditUser from './ActionTable/ActEditUser';
import ActEnableUser from './ActionTable/ActEnableUser';
import ActDisableUser from './ActionTable/ActDisableUser';
import ActSoftDelete from './ActionTable/ActSoftDelete';
import EditUserModal from './Dialogs/EditUserModal';
import EnableUserModal from './Dialogs/EnableUserModal';
import DisableUserModal from './Dialogs/DisableUserModal';
import SoftDeleteUserModal from './Dialogs/SoftDeleteUserModal';
import RequestButton from './BtnRequest';
import FilterTable from './FilterTable';
import { Card, Col, Row, Table, Typography } from 'antd';
import { Stack } from '@mui/material';
import Status from './Status';
import DeleteConfirmationModal from './Dialogs/DialogsDelete';
import ActionMenu from './ActionTable/ActionMenu';
import BlockModal from './Dialogs/DialogsBlock';
import { role_options } from './BtnRequest/RequestDialog';
import UserRolesBadge from './UserRolesBadge';
import UserRolesDisplay from './UserRolesDisplay';
import { usePermission } from '@contexts/Auth/UsePermission';

const getColumns = ({
  refetch,
  setOpen,
  setOpenView,
  setOpenEdit,
  setOpenDelete,
  setOpenEnable,
  setOpenDisable,
  setOpenSoftDelete,
  setUserInfo,
  setOpenBlocked,
  userManagement
}) => {
  return [
    {
      title: 'Tên đăng nhập',
      dataIndex: 'user_name',
      render: (_, d) => (
        <Typography style={{ fontSize: '14px', fontWeight: 500, color: '#00904A' }}>
          {d?.user_name}
        </Typography>
      ),
      width: 220
    },
    {
      title: 'Vai trò',
      dataIndex: 'roleDetails',
      render: (_, d) => <UserRolesDisplay roleDetails={d.roleDetails} maxDisplay={2} />
    },
    {
      title: 'Nhà máy',
      dataIndex: 'branch_names',
      render: (_, d) => (
        <div style={{ fontSize: '14px', fontWeight: 400, color: '#192434' }}>
          {d?.branch_names?.length > 0
            ? d.branch_names.map((name, index) => (
                <div
                  key={index}
                  style={{ marginBottom: index < d.branch_names.length - 1 ? '4px' : 0 }}>
                  {name}
                </div>
              ))
            : '-'}
        </div>
      )
    },
    {
      title: 'Tổ quản lý',
      dataIndex: 'group_names',
      render: (_, d) => (
        <div style={{ fontSize: '14px', fontWeight: 400, color: '#192434' }}>
          {d?.group_names?.length > 0
            ? d.group_names.map((name, index) => (
                <div
                  key={index}
                  style={{ marginBottom: index < d.group_names.length - 1 ? '4px' : 0 }}>
                  {name}
                </div>
              ))
            : '-'}
        </div>
      )
    },
    {
      title: 'Thời gian tạo',
      dataIndex: 'created_at',
      render: (_, d) => (
        <Typography style={{ fontSize: '14px', fontWeight: 400, color: '#192434' }}>
          {moment(d.created_at).format('DD-MM-YYYY HH:mm')}
        </Typography>
      )
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      render: (_, d) => <Status d={d} />,
      width: 160
    },
    {
      title: 'Hành động',
      width: 180,
      dataIndex: 'actions',
      render: (_, d) => (
        <>
          {userManagement.view && (
            <ActViewDetail userInfo={d} setUserInfo={setUserInfo} setOpenView={setOpenView} />
          )}
          {userManagement.edit && (
            <ActEditUser userInfo={d} setUserInfo={setUserInfo} setOpenEdit={setOpenEdit} />
          )}
          {userManagement.edit && d.is_active && !d.deleted_at && (
            <ActDisableUser
              userInfo={d}
              setUserInfo={setUserInfo}
              setOpenDisable={setOpenDisable}
            />
          )}
          {userManagement.edit && !d.is_active && !d.deleted_at && (
            <ActEnableUser userInfo={d} setUserInfo={setUserInfo} setOpenEnable={setOpenEnable} />
          )}
          {userManagement.delete && (
            <ActSoftDelete
              userInfo={d}
              setUserInfo={setUserInfo}
              setOpenSoftDelete={setOpenSoftDelete}
            />
          )}
        </>
      )
    }
  ];
};
const ListUserOperator = () => {
  const { userManagement } = usePermission();
  const [open, setOpen] = React.useState(false);
  const [openView, setOpenView] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [openEnable, setOpenEnable] = React.useState(false);
  const [openDisable, setOpenDisable] = React.useState(false);
  const [openSoftDelete, setOpenSoftDelete] = React.useState(false);
  const [openBlocked, setOpenBlocked] = useState(false);
  const [userInfo, setUserInfo] = React.useState(null);
  const [dataFilter, setDataFilter] = React.useState();
  const [flagSearch, setFlagSearch] = React.useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const { data, isLoading, refetch, error, isSuccess } = useQuery(
    ['admin-get-user-operator', currentPage, pageSize],
    () =>
      rootApi.get(`/api/users/search`, {
        params: {
          page: currentPage,
          size: pageSize,
          keyWord: dataFilter?.search_username ?? undefined,
          status: dataFilter?.status ?? undefined
        }
      })
  );
  useEffect(() => {
    refetch();
  }, [flagSearch]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleChangePageSize = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (data?.data) {
      setTotalItems(data.data.meta?.total);
    }
  }, [data]);

  return (
    <>
      <DialogsViewDetail
        openView={openView}
        setOpenView={setOpenView}
        userInfo={userInfo}
        refetch={refetch}
      />
      <EditUserModal
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        userInfo={userInfo}
        onSuccess={refetch}
      />
      <EnableUserModal
        open={openEnable}
        onClose={() => setOpenEnable(false)}
        userInfo={userInfo}
        onSuccess={refetch}
      />
      <DisableUserModal
        open={openDisable}
        onClose={() => setOpenDisable(false)}
        userInfo={userInfo}
        onSuccess={refetch}
      />
      <SoftDeleteUserModal
        open={openSoftDelete}
        onClose={() => setOpenSoftDelete(false)}
        userInfo={userInfo}
        onSuccess={refetch}
      />
      {/* <DialogsChangeRole open={open} setOpen={setOpen} userInfo={userInfo} refetch={refetch} /> */}
      <DeleteConfirmationModal
        visible={openDelete}
        setVisible={setOpenDelete}
        userInfo={userInfo}
        refetch={refetch}
      />
      {/* <BlockModal
        visible={openBlocked}
        setVisible={setOpenBlocked}
        userInfo={userInfo}
        refetch={refetch}
      /> */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Typography.Title level={4} style={{ color: '#0051A9', margin: 0 }}>
            Quản lý người dùng
          </Typography.Title>
        </Col>
        <Col>{userManagement.create && <RequestButton refetch={refetch} />}</Col>
      </Row>
      <Box width="100%" overflow="auto">
        <Card bodyStyle={{ padding: 8 }}>
          <FilterTable
            dataFilter={dataFilter}
            onChange={setDataFilter}
            flagSearch={flagSearch}
            setFlagSearch={setFlagSearch}
            users={data?.data.data}
          />
        </Card>
        <Table
          bordered
          size="small"
          loading={isLoading}
          dataSource={data?.data.data || []}
          columns={getColumns({
            refetch,
            setOpen,
            setOpenView,
            setOpenEdit,
            setOpenDelete,
            setOpenEnable,
            setOpenDisable,
            setOpenSoftDelete,
            setUserInfo,
            setOpenBlocked,
            userManagement
          })}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalItems,
            showSizeChanger: true,
            onChange: handleChangePage,
            onShowSizeChange: handleChangePageSize,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
          }}
          style={{ borderRadius: 0, thead: { backgroundColor: '#DBDFE5', color: '#626D7C' } }}
          scroll={{ x: 'max-content' }}
        />
      </Box>
    </>
  );
};

export default compose(withPaginate)(ListUserOperator);
